import React from "react";
import {Card, Col, Row} from "react-bootstrap";

const SeoBottomBlock = ({ blocks }) => {

    if (!blocks) return null;

    return (



                    <Card className="shadow-sm rounded small p-3">
                        <h2 className="fs-6 text-muted mb-2">{blocks.block1_H2}</h2>
                        <p className="text-muted">{blocks.block1_P}</p>

                        <h3 className="mt-0 text-muted fs-6 mb-1">{blocks.block2_H3}</h3>
                        <p className="text-muted">{blocks.block2_P}</p>

                        <h3 className="mt-0 text-muted fs-6 mb-1">{blocks.block3_H3}</h3>
                        <p className="text-muted">{blocks.block3_P}</p>

                        <h3 className="mt-0 text-muted fs-6 mb-1">{blocks.block4_H3}</h3>
                        <p className="text-muted">{blocks.block4_P}</p>

                        <h3 className="mt-0 text-muted fs-6 mb-1">{blocks.block5_H3}</h3>
                        <p className="text-muted">{blocks.block5_P}</p>
                    </Card>



    );
};

export default SeoBottomBlock;